import { ExternalLink } from 'components'
import ImageLoader from '../ImageLoader'

import './style.scss'

const MetaDataPreviewCard = ({
  title,
  description,
  imageUrl,
  url,
  onClose,
}: {
  title: string
  description: string
  imageUrl: string
  url: string
  isLoading?: boolean
  onClose?: Function
}) => {
  return (
    <div className="PostList__item__url-preview">
      <ExternalLink className="MetaDataPreviewCard" data-nosnippet href={url}>
        {onClose && (
          <div
            className="MetaDataPreviewCard__close"
            role="button"
            onClick={(e) => {
              e.preventDefault()
              onClose()
            }}
          />
        )}

        <ImageLoader className="MetaDataPreviewCard__image" url={imageUrl} />

        <div className="MetaDataPreviewCard__content">
          <div className="MetaDataPreviewCard__title">{title}</div>
          <div className="MetaDataPreviewCard__description">{description}</div>
        </div>
      </ExternalLink>
    </div>
  )
}

export default MetaDataPreviewCard
